/* eslint-disable react/forbid-prop-types,import/no-unresolved,import/prefer-default-export,react-hooks/exhaustive-deps */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import MonavateCardImage from 'assets/images/cl-card-monavate.png';
import UsCardVisaImage from 'assets/images/cl-card-galileo-visa.png';
import UsCardVisaVirtualImage from 'assets/images/cl-card-galileo-visa-virtual.png';
import UsCardMastercardImage from 'assets/images/cl-card-galileo-mastercard.png';
import UsCardMastercardVirtualImage from 'assets/images/cl-card-galileo-mastercard-virtual.png';
import { VerificationState } from '../../../../../utilities/constants';
import {
  CARD_NETWORKS,
  cardProviders,
  CardState,
  getCardCapabilities,
  isConnectFinancial,
  mainCardTypes,
  orderCardFlowScreens,
} from '../../../../../screens/Card/constants';

export const OrderCardMobileComponent = ({
  showScreen,
  cardStatus,
  defaultNetwork,
  isOrderCardAllowed,
  isUsUser,
  userCardProvider,
  userRegionSettings,
  orderableCardTypes,
  cardType,
  orderCardHandler,
  userVerificationState,
  bottomValue,
}) => {
  const { t: translate } = useTranslation();

  const { usCardArtwork } = getCardCapabilities(userCardProvider);

  const cardDesignImage = useMemo(() => {
    if (
      usCardArtwork &&
      defaultNetwork === CARD_NETWORKS.VISA &&
      userRegionSettings?.default_card_type?.toLowerCase() === mainCardTypes.VIRTUAL
    ) {
      return {
        src: UsCardVisaVirtualImage,
        paddingBottom: '3rem',
      };
    }

    if (usCardArtwork && defaultNetwork === CARD_NETWORKS.VISA) {
      return {
        src: UsCardVisaImage,
        paddingBottom: '3rem',
      };
    }

    if (
      usCardArtwork &&
      defaultNetwork === CARD_NETWORKS.MASTERCARD &&
      userRegionSettings?.default_card_type?.toLowerCase() === mainCardTypes.VIRTUAL
    ) {
      return {
        src: UsCardMastercardVirtualImage,
        paddingBottom: '3rem',
      };
    }

    if (usCardArtwork && defaultNetwork === CARD_NETWORKS.MASTERCARD) {
      return {
        src: UsCardMastercardImage,
        paddingBottom: '3rem',
      };
    }

    if (
      userCardProvider === cardProviders.MONAVATE ||
      (userCardProvider === cardProviders.MONAVATE &&
        userRegionSettings?.default_card_type?.toLowerCase() === mainCardTypes.VIRTUAL)
    ) {
      return {
        src: MonavateCardImage,
      };
    }
    return {
      src: MonavateCardImage,
    };
  }, [userCardProvider, userRegionSettings, defaultNetwork]);

  const promoTitle = useMemo(() => {
    if (cardStatus && cardStatus?.cardState === CardState.PENDING) {
      return translate('promo_pending_card_title');
    }
    if (isUsUser) {
      return translate('promo_title_us');
    }
    return translate('promo_title');
  }, [cardStatus]);

  const promoSubtitle = useMemo(() => {
    if (cardStatus && cardStatus?.cardState === CardState.PENDING) {
      return translate(
        isConnectFinancial(userCardProvider)
          ? 'card_connect_financial_pending_subtitle'
          : 'promo_pending_card_subtitle'
      );
    }

    if (isUsUser) {
      return translate('promo_subtitle_us');
    }

    if (
      !orderableCardTypes?.includes(mainCardTypes.PHYSICAL.toUpperCase()) &&
      cardType === mainCardTypes.VIRTUAL
    ) {
      return translate('promo_virtual_subtitle');
    }

    return translate('promo_subtitle');
  }, [cardStatus, orderableCardTypes, cardType, userCardProvider]);

  const isBannerVisible = useMemo(() => {
    if (
      userVerificationState === VerificationState.PENDING ||
      userVerificationState === VerificationState.CHECKED ||
      (cardStatus && cardStatus?.cardState === CardState.PENDING)
    ) {
      return true;
    }
    return false;
  }, [userVerificationState, cardStatus]);

  const renderBanner = () => (
    <div className="d-md-none bg-info d-flex flex-row w-100 align-items-center p-3">
      <i className="icon icon-info-icon me-3 text-f4" />
      <p className="text-white text-f6">
        {!isOrderCardAllowed
          ? translate('card_verification_banner_info')
          : translate(
              isConnectFinancial(userCardProvider)
                ? 'card_connect_financial_pending_banner_info'
                : 'card_pending_banner_info'
            )}
      </p>
    </div>
  );

  const btnLabel = useMemo(() => {
    if (userVerificationState === VerificationState.UNVERIFIED) {
      return translate('verify_account_btn_label');
    }
    if (isUsUser) {
      return translate('card_order_try_now_btn_label_us');
    }

    return translate('card_order_try_now_btn_label');
  }, [isUsUser, userVerificationState]);

  return (
    <div
      className="d-flex d-md-none flex-column justify-content-between hide-scroll"
      style={{ flex: 1, overflowY: 'auto' }}>
      <div>
        {isBannerVisible && renderBanner()}
        {cardStatus?.cardState !== CardState.PENDING && (
          <h1 className="pt-3 ps-4" style={{ fontSize: '2.13rem', zIndex: 1 }}>
            {translate('order_card_type_title')}
          </h1>
        )}
      </div>

      <div className="d-flex flex-column" style={{ paddingBottom: '1.5rem' }}>
        <div className="text-center">
          <img
            src={cardDesignImage?.src}
            alt="card-order-no-text-hand.png"
            style={{
              objectFit: 'contain',
              width: '90%',
              paddingBottom: cardDesignImage?.paddingBottom || '0',
            }}
          />
        </div>
        <div
          className="bg-lighter p-4"
          style={{
            position: 'relative',
            borderTopRightRadius: '1.5rem',
            borderTopLeftRadius: '1.5rem',
            boxShadow: '0px 32px 80px 0px #26374C0D',
            marginBottom: bottomValue,
          }}>
          <h1
            className="promo-title mb-2 w-100 text-uppercase"
            style={{
              fontSize: cardStatus?.cardState !== CardState.PENDING ? '2.125rem' : '1.375rem',
              lineHeight: cardStatus?.cardState !== CardState.PENDING ? '3rem' : '1.875rem',
            }}>
            {promoTitle}
          </h1>
          <p className={`text-shadow m-0 ${isUsUser ? 'mb-3' : 'mb-5'} text-left w-100 d-block`}>
            {promoSubtitle}
          </p>
          {isUsUser && userCardProvider === cardProviders.GALILEO && (
            <button
              onClick={() => showScreen(orderCardFlowScreens.CARD_TERMS)}
              type="button"
              className="link text-decoration-none text-f6 border-0 bg-transparent text-primary p-0 mb-5">
              {translate('terms_of_card_label')}
            </button>
          )}
          {cardStatus?.cardState !== CardState.PENDING && (
            <div
              className="d-flex flex-column align-items-center justify-content-start fixed-bottom bg-lighter pt-3 pb-2 px-3"
              style={{ bottom: '75px', zIndex: 100 }}>
              <button
                type="button"
                className="btn btn-primary py-3 w-100"
                disabled={!isOrderCardAllowed}
                onClick={orderCardHandler}>
                {btnLabel}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

OrderCardMobileComponent.propTypes = {
  orderCardHandler: PropTypes.func.isRequired,
  userVerificationState: PropTypes.number.isRequired,
  showScreen: PropTypes.func.isRequired,
  cardStatus: PropTypes.object.isRequired,
  defaultNetwork: PropTypes.string.isRequired,
  isOrderCardAllowed: PropTypes.bool.isRequired,
  isUsUser: PropTypes.bool.isRequired,
  userCardProvider: PropTypes.string.isRequired,
  userRegionSettings: PropTypes.object.isRequired,
  orderableCardTypes: PropTypes.array.isRequired,
  cardType: PropTypes.string.isRequired,
  bottomValue: PropTypes.number.isRequired,
};
